import axiosInstance from './axiosInstance';

export interface ReferralInfo {
  referral_code: string | null;
  referral_link: string;
  total_referred: number;
  credits_earned: number;
  referral_limit: number;
  referrals_remaining: number;
}

export interface GoogleContactsResponse {
  message: string;
  new_contacts: number;
  total_fetched: number;
}

export const referralService = {
  async getReferralInfo(): Promise<ReferralInfo> {
    const response = await axiosInstance.get<ReferralInfo>('/api/v1/referral/info');

    return response.data;
  },

  async importGoogleContacts(accessToken: string): Promise<GoogleContactsResponse> {
    const response = await axiosInstance.post<GoogleContactsResponse>('/api/v1/referral/google-contacts', {
      access_token: accessToken,
    });

    return response.data;
  },
};
